// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup{
    padding-top:130px;
    padding-bottom: 20px;
    background-color: rgba(0,0,0,0.1);
    display: flex;
    justify-content: center;
    
}

.signup-card{
    width:60%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: left;
    border-radius: 10px;
    padding: 50px;
}

.signup-card h1{
    font-family: 'Poppins', sans-serif;
    font-weight: 520;
}
.signup-form{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
}

.signup-form input{
    height:50px;
    margin-bottom: 20px;
    width:90%;
    font-size: large;
    font-family: 'Poppins', sans-serif;
    font-weight: 100;
    padding-left: 20px;
}

.signup-form button{
    height:50px;
    width:200px;
    background-color: #e42727;
    border: none;
    font-size: large;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 20px;
    border-radius: 5px;
    cursor: pointer;
        position: relative;
        overflow: hidden;
        z-index: 0;

}



.signup-form button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #ffa406;
    z-index: -1;
    border-radius: 5px;
    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}



.signup-form button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}

.signup-form a{
    font-family: 'Poppins', sans-serif;
    font-size: medium;

}

.signup-erros{
    font-family: 'Poppins', sans-serif;
    font-size: medium;
    color:red;
}

.signup-navigation a{
    margin-right:50px;
}

@media screen and (max-width:768px){
    .signup {
            padding-top: 180px;
            padding-bottom: 20px;
            background-color: rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: center;
           
    
        }
        .signup-card h1 {
            font-family: 'Poppins', sans-serif;
            font-weight: 520;
            margin:10px;
        }
        .signup-card {
            width: 90%;
            height:fit-content;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: left;
            align-items: left;
            border-radius: 10px;
            padding: 0px;
        }
        .signup-form input {
            height: 40px;
            margin:10px;
            width: 70%;
            font-size: large;
            font-family: 'Poppins', sans-serif;
            font-weight: 100;
            padding:0px;
        }
        .signup-navigation{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .signup-navigation a{
            margin-right: 0px;
        }
        .signup-form button {
            height: 50px;
            width: 200px;
            background-color: #F9C12E;
            border: none;
            font-size: large;
            font-family: 'Poppins', sans-serif;
            margin-bottom: 10px;
            border-radius: 5px;
    
        }

}`, "",{"version":3,"sources":["webpack://./src/Styles/Signup.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;;AAE3B;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;QACX,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;;AAElB;;;;AAIA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;;;AAIA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;;AAErB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;YACQ,kBAAkB;YAClB,oBAAoB;YACpB,oCAAoC;YACpC,aAAa;YACb,uBAAuB;;;QAG3B;QACA;YACI,kCAAkC;YAClC,gBAAgB;YAChB,WAAW;QACf;QACA;YACI,UAAU;YACV,kBAAkB;YAClB,sBAAsB;YACtB,aAAa;YACb,sBAAsB;YACtB,qBAAqB;YACrB,iBAAiB;YACjB,mBAAmB;YACnB,YAAY;QAChB;QACA;YACI,YAAY;YACZ,WAAW;YACX,UAAU;YACV,gBAAgB;YAChB,kCAAkC;YAClC,gBAAgB;YAChB,WAAW;QACf;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,mBAAmB;QACvB;QACA;YACI,iBAAiB;QACrB;QACA;YACI,YAAY;YACZ,YAAY;YACZ,yBAAyB;YACzB,YAAY;YACZ,gBAAgB;YAChB,kCAAkC;YAClC,mBAAmB;YACnB,kBAAkB;;QAEtB;;AAER","sourcesContent":[".signup{\n    padding-top:130px;\n    padding-bottom: 20px;\n    background-color: rgba(0,0,0,0.1);\n    display: flex;\n    justify-content: center;\n    \n}\n\n.signup-card{\n    width:60%;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: left;\n    align-items: left;\n    border-radius: 10px;\n    padding: 50px;\n}\n\n.signup-card h1{\n    font-family: 'Poppins', sans-serif;\n    font-weight: 520;\n}\n.signup-form{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    \n}\n\n.signup-form input{\n    height:50px;\n    margin-bottom: 20px;\n    width:90%;\n    font-size: large;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 100;\n    padding-left: 20px;\n}\n\n.signup-form button{\n    height:50px;\n    width:200px;\n    background-color: #e42727;\n    border: none;\n    font-size: large;\n    font-family: 'Poppins', sans-serif;\n    margin-bottom: 20px;\n    border-radius: 5px;\n    cursor: pointer;\n        position: relative;\n        overflow: hidden;\n        z-index: 0;\n\n}\n\n\n\n.signup-form button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #ffa406;\n    z-index: -1;\n    border-radius: 5px;\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n\n\n.signup-form button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n\n.signup-form a{\n    font-family: 'Poppins', sans-serif;\n    font-size: medium;\n\n}\n\n.signup-erros{\n    font-family: 'Poppins', sans-serif;\n    font-size: medium;\n    color:red;\n}\n\n.signup-navigation a{\n    margin-right:50px;\n}\n\n@media screen and (max-width:768px){\n    .signup {\n            padding-top: 180px;\n            padding-bottom: 20px;\n            background-color: rgba(0, 0, 0, 0.1);\n            display: flex;\n            justify-content: center;\n           \n    \n        }\n        .signup-card h1 {\n            font-family: 'Poppins', sans-serif;\n            font-weight: 520;\n            margin:10px;\n        }\n        .signup-card {\n            width: 90%;\n            height:fit-content;\n            background-color: #fff;\n            display: flex;\n            flex-direction: column;\n            justify-content: left;\n            align-items: left;\n            border-radius: 10px;\n            padding: 0px;\n        }\n        .signup-form input {\n            height: 40px;\n            margin:10px;\n            width: 70%;\n            font-size: large;\n            font-family: 'Poppins', sans-serif;\n            font-weight: 100;\n            padding:0px;\n        }\n        .signup-navigation{\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n        }\n        .signup-navigation a{\n            margin-right: 0px;\n        }\n        .signup-form button {\n            height: 50px;\n            width: 200px;\n            background-color: #F9C12E;\n            border: none;\n            font-size: large;\n            font-family: 'Poppins', sans-serif;\n            margin-bottom: 10px;\n            border-radius: 5px;\n    \n        }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
